import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Truck } from "lucide-react";
import { Logo } from "./Logo";
import { HalalBadge } from "./Navbar";
import { DELIVERY_NOTICE } from "../data/site";
import { NewsletterSignup } from "./NewsletterSignup";

export const Footer = () => (
  <footer className="bg-ink text-parchment/80" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
      <div className="grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo dark />
          <p className="mt-4 max-w-sm text-sm leading-relaxed">
            Gourmet halal meal prep and full-service catering, cooked in Woodbridge, VA and
            delivered across the DMV.
          </p>
          <div className="mt-5">
            <HalalBadge />
          </div>
          <NewsletterSignup />
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-saffron">Explore</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/" data-testid="footer-link-home" className="transition-colors hover:text-saffron">Home</Link></li>
            <li><Link to="/meal-prep" data-testid="footer-link-meal-prep" className="transition-colors hover:text-saffron">Meal Prep</Link></li>
            <li><Link to="/catering" data-testid="footer-link-catering" className="transition-colors hover:text-saffron">Catering</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="transition-colors hover:text-saffron">Contact Us</Link></li>
            <li><Link to="/account" data-testid="footer-link-account" className="transition-colors hover:text-saffron">My Account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-saffron">Reach Us</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><MapPin size={14} className="text-saffron" /> Woodbridge, VA</li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-saffron" /> (571) 833-1906</li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-saffron" /> eathiplate@gmail.com</li>
            <li className="flex items-start gap-2"><Truck size={14} className="mt-0.5 shrink-0 text-saffron" /> {DELIVERY_NOTICE}</li>
          </ul>
        </div>
      </div>
      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-parchment/10 pt-6 text-xs text-parchment/50 sm:flex-row">
        <span>© {new Date().getFullYear()} HiPlate. All rights reserved.</span>
        <span className="font-mono">Cooked with intention. Delivered with care.</span>
      </div>
    </div>
  </footer>
);
